module.exports = class AlreadyEndedError extends Error {}